import React from 'react';

import { Root, Path } from './index.styled';

const MarkerBase = () => {
  return (
    <Root>
      <svg viewBox="0 0 1000 1000">
        <g>
          <Path d="m 499.71886,15.000074 c -0.0674,5.5e-5 -0.13455,0.0018 -0.20188,0.0019 -191.59894,0.26614 -344.51475,151.989796 -344.51469,344.980866 -0.88626,271.84974 258.04884,313.49004 321.37714,603.6091 2.38415,10.14882 10.67832,21.40739 22.65452,21.40799 0.16318,0 0.3224,-0.0127 0.48303,-0.0209 0.16064,-0.008 0.32273,-0.0116 0.48302,-0.0209 0.16029,0.009 0.32237,0.0129 0.48301,0.0209 0.16064,0.008 0.31986,0.0209 0.48305,0.0209 11.9762,-6e-4 20.27035,-11.25917 22.65452,-21.40799 63.32829,-290.11906 322.26338,-331.75936 321.37713,-603.6091 6e-5,-192.99107 -152.91576,-344.714726 -344.5147,-344.980866 -0.0673,-10e-5 -0.13443,-0.0018 -0.20187,-0.0019 l -0.28114,1e-6 z" />
        </g>
      </svg>
    </Root>
  );
};

export default MarkerBase;
